import React from "react";
import { Field, FieldProps } from "formik";
import PlanSelectorStep from "./planSelectorStep";
import CompanyInfoStep from "./companyInfoStep";
import UserManagementOnboardingStep from "./userManagementOnboardingStep";
import OnboardingSettingsStep from "./onboardingSettingsStep";
import OnboardingPaymentStep from "./onboardingPaymentStep";
import OnboardingWelcomeStep from "./onboardingWelcomeStep";
import styles from "../../components/forms/forms.module.css";
import onboardingStyles from "./companyOnboading.module.css";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { getStepHeader, sanitizeUrlString } from "../../utils/constants";
import i18n from "../../i18n";

const StepRenderer = ({
  stepNumber,
  values,
  setFieldValue,
  errors,
  touched,
  onPaymentSuccess,
  languageId,
  paymentCompleted,
}: {
  stepNumber: number;
  values: any;
  setFieldValue: any;
  errors: any;
  touched: any;
  onPaymentSuccess?: () => void;
  languageId?: string | null;
  paymentCompleted?: boolean;
}) => {
  switch (stepNumber) {
    case 1:
      return (
        <div>
          <h2 className={onboardingStyles.stepHeader}>{getStepHeader(stepNumber)}</h2>
          <ul className={`${styles.form__list} ${styles.form__list_type_oneColumn} ${onboardingStyles.form__list}`}>
          <li>
            <label className={styles.form__label}>{t("ONBOARDING_COMPANY_NAME")}</label>
            <Field 
              name="name" 
              placeholder={t("ONBOARDING_COMPANY_NAME")} 
              className={styles.form__input}
            />
            {errors?.name && touched?.name && <p className="error">{t(errors.name)}</p>}
            {/* <ErrorMessage name="name" component="div" className="error" /> */}
          </li>

          <li>
            <label className={styles.form__label}>{t("ONBOARDING_COMPANY_NAME_ENGLISH")}</label>
            <Field name="nameEn">
              {({ field, form }: FieldProps) => (
               <input
               {...field}
               placeholder={t("ONBOARDING_COMPANY_NAME_ENGLISH")}
               className={styles.form__input}
               onChange={(e) => {
                 const sanitizedValue = sanitizeUrlString(e.target.value);
                 if (sanitizedValue.length <= 45) {
                   form.setFieldValue(field.name, sanitizedValue);
                 }
               }}
             />
              )}
            </Field>
            {errors?.nameEn && touched?.nameEn && <p className="error">{t(errors.nameEn)}</p>}
          </li>

          <li>
            <label className={styles.form__label}>{t("ONBOARDING_EMAIL")}</label>
            <Field 
              name="email" 
              placeholder={t("ONBOARDING_EMAIL_PLACEHOLDER")} 
              className={styles.form__input}
            />
            {errors?.email && touched?.email && <p className="error">{t(errors.email)}</p>}
          </li>

          <li>
            <label className={styles.form__label}>{t("ONBOARDING_PHONE")}</label>
            <Field 
              name="phone" 
              placeholder={t("ONBOARDING_PHONE_PLACEHOLDER")} 
              className={styles.form__input}
              dir={'ltr'}
              style={i18n.language === 'he' ? { textAlign: 'end' } : {}}
            />
            {errors?.phone && touched?.phone && <p className="error">{t(errors.phone)}</p>}
          </li>
        </ul>
        </div>
      );
    case 2:
      return (
        <div>
          <h2 className={onboardingStyles.stepHeader}>{getStepHeader(stepNumber)}</h2>
          <ul className={`${styles.form__list} ${styles.form__list_type_oneColumn} ${onboardingStyles.form__list}`}>
          <li>
            <label className={styles.form__label}>{t("ONBOARDING_CONTACT_PERSON")}</label>
            <Field 
              name="contactFullName" 
              placeholder={t("ONBOARDING_FULL_NAME")} 
              className={styles.form__input}
            />
            {errors?.contactFullName && touched?.contactFullName && <p className="error">{t(errors.contactFullName)}</p>}
          </li>

          <li>
            <label className={styles.form__label}>{t("ONBOARDING_CONTACT_POSITION")}</label>
            <Field 
              name="positionTitle" 
              placeholder={t("ONBOARDING_FULL_POSITION")} 
              className={styles.form__input}
            />
            {errors?.positionTitle && touched?.positionTitle && <p className="error">{t(errors.positionTitle)}</p>}
          </li>
        </ul>
        </div>
      );
    case 3:
      return (
        <div>
          <h2 className={onboardingStyles.stepHeader}>{getStepHeader(stepNumber)}</h2>
          <CompanyInfoStep
            values={values}
            setFieldValue={setFieldValue}
            errors={errors}
            touched={touched}
          />
        </div>
      );
    case 4:
      return (
        <div>
          <h2 className={onboardingStyles.stepHeader}>{getStepHeader(stepNumber)}</h2>
          <PlanSelectorStep
            stepNumber={stepNumber}
            values={values}
            setFieldValue={setFieldValue}
            languageId={languageId}
          />
        </div>
      );
    case 5:
      return (
        <div>
          <h2 className={onboardingStyles.stepHeader}>{getStepHeader(stepNumber)}</h2>
          <OnboardingPaymentStep
            onPaymentSuccess={onPaymentSuccess}
            companyGuid={values.guid}
            planId={values.selectedPlanId}
            paymentPeriodTypeId={values.paymentsPeriodTypesId}
            contactFullName={values.contactFullName}
            disabled={paymentCompleted}
          />
        </div>
      );
    case 6:
      return (
        <div>
          <OnboardingWelcomeStep
            values={{
              name: values.name,
              email: values.email,
            }}
          />
        </div>
      );
   
    default:
      return null;
  }
};

export default StepRenderer;
